import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { DefaultWrapper } from '../../components/Layout/DefaultWrapper';
import MenuOpener from '../../components/MenuOpener';
import Footer from '../../components/Layout/Footer';

// Screens
import FeatureScreen from './screens/Feature';
import ClientsScreen from './screens/Clients';
import TestimonialsScreen from './screens/Testimonials';
import FooterScreen from './screens/Footer';

const About = () => (
  <DefaultWrapper>
    {/* menu */}
    <MenuOpener className="menu-opener" />
    {/* Screens */}
    <FeatureScreen />
    <ClientsScreen />
    <TestimonialsScreen />
    <FooterScreen />
    <Footer />
  </DefaultWrapper>
);

export default connect()(About);



// WEBPACK FOOTER //
// ./src/pages/About/index.jsx